import { render, staticRenderFns } from "./navbtns.vue?vue&type=template&id=797dd45f&scoped=true&"
import script from "./navbtns.vue?vue&type=script&lang=js&"
export * from "./navbtns.vue?vue&type=script&lang=js&"
import style0 from "./navbtns.vue?vue&type=style&index=0&id=797dd45f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dd45f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VList,VListItem,VRow,VTab,VTabs})
